import React, { useState, useEffect, memo } from 'react';
import Sidenav from './Sidenav';
import SidenavPartner from './SidenavPartner';

function readRoleFromStorage() {
  try {
    if (typeof window === 'undefined') return '';
    const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}');
    return (adminUser.role || '').toLowerCase();
  } catch {
    return '';
  }
}

function SidenavSelector(props) {
  // Lit le rôle UNE SEULE FOIS au montage (au lieu de chaque render)
  const [role, setRole] = useState(readRoleFromStorage);

  // Resync uniquement si le storage change dans un autre onglet
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'adminUser') setRole(readRoleFromStorage());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  if (role === 'sous admin') return <SidenavPartner {...props} />;
  return <Sidenav {...props} />;
}

export default memo(SidenavSelector);
